import React, { useEffect, useState } from 'react';
import {
  Box,
  CircularProgress,
  Paper,
  Button,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AdminDashboard from './DashBoard/AdminDashboard';
import UserDashboard from './DashBoard/UserDashboard';
import ManagerDashboard from './DashBoard/ManagerDashboard';
import SupervisorDashboard from './DashBoard/ManagerDashboard';
import DefaultDashboard from './DashBoard/DefaultDashboard';
import Header from './HeaderPage';
import logo from '../asset/logo32.png';
import {
  LabelImportantRounded as LabelImportantRoundedIcon,
  TravelExploreRounded as TravelExploreRoundedIcon,
  BarChart as BarChartIcon,
  Dashboard as DashboardIcon,
  PieChart as PieChartIcon,
  Assessment as AssessmentIcon,
  Settings as SettingsIcon,
  ConstructionSharp as ConstructionSharpIcon,
  QueryBuilderSharp as QueryBuilderSharpIcon,
  TextSnippetSharp as TextSnippetSharpIcon
} from '@mui/icons-material';

import ExcelUploader from '../pages/ExcelUploader/ExcelUploader';
import QueryUploader from '../pages/QueryUploader/QueryUploader';
import DocumentUploader from '../pages/DocumentUploader/DocumentUploader';
import RichTextEditor from './RichTextEditor/RichTextEditor';
import SettingTools from './SettingTools/SettingTools';
import FileExplorer from '../pages/FolderViewer/FolderViewer';
import ListIcon from '@mui/icons-material/List';




function DashboardPage() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedMenu, setSelectedMenu] = useState('Dashboard');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const userData = {
      userfullname: localStorage.getItem('userfullname'),
      userrole: localStorage.getItem('userrole'),
      uname: localStorage.getItem('uname'),
      emaild: localStorage.getItem('emaild'),
    };

    if (userData.userfullname && userData.userrole) {
      setUser(userData);
    } else {
      navigate('/');
    }

    setLoading(false);
  }, [navigate]);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  const roleComponentMap = {
    '1': UserDashboard,
    '2': ManagerDashboard,
    '3': SupervisorDashboard,
    '9': AdminDashboard
  };
  const DashboardComponent = roleComponentMap[user?.userrole] || DefaultDashboard;

  const contentComponents = {
    Dashboard: DashboardComponent,
    'Import Excel/CSV File': ExcelUploader,
    'Data Explore from Query': QueryUploader,
    'Import Document Files': DocumentUploader,
    'Rich Text Box': RichTextEditor,
    'File Explorer':FileExplorer,
    Reports: () => <div style={{ padding: 20 }}>📊 Select a sub-report</div>,
    'Report 1': () => <div style={{ padding: 20 }}>📈 Report 1 content</div>,
    'Report 2': () => <div style={{ padding: 20 }}>📉 Report 2 content</div>,
    Settings: SettingTools,
  };

  const SelectedComponent = contentComponents[selectedMenu] || (() => <div style={{ padding: 20 }}>Select a menu</div>);

  const handleMenuSelect = (item) => {
    setSelectedMenu(item);
    setDrawerOpen(false);
  };

  const menuItems = [
    { label: 'Dashboard', icon: <DashboardIcon sx={{ color: '#f993ba' }}/> },
    {
      label: 'Utilities',
      icon: <ConstructionSharpIcon sx={{ color: 'red' }}/>,
      children: [
        { label: 'Import Excel/CSV File', icon: <LabelImportantRoundedIcon sx={{ color: '#1769aa' }} /> },
        { label: 'Import Document Files', icon: <TravelExploreRoundedIcon sx={{ color: '#ffea00' }}/> },
        { label: 'Data Explore from Query', icon: <QueryBuilderSharpIcon sx={{ color: '#ff3d00' }}/> },
        { label: 'Rich Text Box', icon: <TextSnippetSharpIcon sx={{ color: '#00a152' }}/> },
        { label: 'File Explorer', icon: <ListIcon sx={{ color: '#c6ff00' }}/> },
      ]
    },
    {
      label: 'Reports',
      icon: <AssessmentIcon sx={{ color: '#f3434f' }}/>,
      children: [
        { label: 'Report 1', icon: <BarChartIcon sx={{ color: '#1976d2' }}/> },
        { label: 'Report 2', icon: <PieChartIcon sx={{ color: '#f3434f' }}/> }
      ]
    },
    { label: 'Settings', icon: <SettingsIcon sx={{ color: '#ff43ff' }}/> }
  ];

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          backgroundColor: '#e8f0fe',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress color="primary" size={60} />
      </Box>
    );
  }

  return (
    <>
      <Header
        firmName="Sriyansh Utilities Library"
        logoUrl={logo}
        username={user?.userfullname || 'User'}
        menuItems={menuItems}
        onMenuSelect={handleMenuSelect}
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
        darkMode={darkMode}
        setDarkMode={setDarkMode}
      />

      <Box
        sx={{
          transition: 'margin-left 0.3s, width 0.3s',
          marginRight: { xs: 0, sm: drawerOpen ? '250px' : 0 },
          width: { xs: '100%', sm: drawerOpen ? 'calc(100% - 250px)' : '100%' },
          padding: 0,
          bgcolor: darkMode ? 'grey.900' : '#f5f5f5',
          color: darkMode ? 'grey.100' : 'text.primary',
        }}
      >
        <Paper sx={{
          padding: 2,
          bgcolor: darkMode ? 'grey.800' : 'white',
          color: darkMode ? 'grey.100' : 'text.primary',
        }}>
          
          <SelectedComponent />
        </Paper>
      </Box>
    </>
  );
}

export default DashboardPage;
